const log = (...a) => console.log('[CALLDBG]', ...a);

export function beginReconnection(svc, force = false) {
    if (svc.state === 'idle') return;
    if (svc._reconnecting && !force) return;

    const now = Date.now();
    if (!svc._reconnectStartedAt) svc._reconnectStartedAt = now;

    svc._reconnecting = true;

    if (svc.state === 'in-call') svc.emitter.emit('reconnecting');
    else svc.emitter.emit('connecting');

    // лидер пробует сразу
    tryIceRestartIfLeader(svc, 'begin');

    svc._reactivateTracks?.();

    clearTimeout(svc._reconnectTimer);
    const loop = async () => {
        if (svc.state === 'idle') return;
        const elapsed = Date.now() - svc._reconnectStartedAt;
        if (elapsed > 5 * 60_000) { svc._cleanup('failed'); return; }
        const s = svc.pc?.connectionState;
        if (s === 'connected') {
            svc._reconnecting = false;
            svc._reconnectStartedAt = 0;
            return;
        }
        tryIceRestartIfLeader(svc, 'timer');
        svc._reconnectTimer = setTimeout(loop, 20_000);
    };
    svc._reconnectTimer = setTimeout(loop, 20_000);
}

export function tryIceRestartIfLeader(svc, tag = 'manual') {
    if (!svc.isLeader || !svc.pc) return;
    const now = Date.now();
    if (!svc._quality) svc._quality = { lastRestartAt: 0 };
    if (now - (svc._quality.lastRestartAt || 0) < 5000) return; // не чаще 5с
    svc._quality.lastRestartAt = now;

    log('maybeIceRestart', tag);
    // restartIce + явный offer
    try {
        if (typeof svc.pc.restartIce === 'function') {
            log('[PC] restartIce()');
            svc.pc.restartIce();
        }
    } catch { /* noop */ }

    svc.makingOffer = true;
    svc.pc.createOffer({ iceRestart: true, offerToReceiveAudio: true, offerToReceiveVideo: true })
        .then(offer => svc.pc.setLocalDescription(offer))
        .then(() => {
            svc.socket.emit('call:offer', { callId: svc.callId, to: svc.partner, sdp: svc.pc.localDescription });
            log('ICE restart offer sent');
        })
        .catch(e => log('ICE restart failed', e?.message || e))
        .finally(() => { svc.makingOffer = false; });
}

export function maybeIceRestart(svc, tag = '') {
    if (!svc.isLeader) return;
    if (!svc._lastRestartAt || (Date.now() - svc._lastRestartAt) > 5000) {
        svc._lastRestartAt = Date.now();
        tryIceRestartIfLeader(svc, tag);
        log('maybeIceRestart', tag);
    }
}
